<v-app style="background-color: #F9F9F9;"><router-view></router-view></v-app>